export const EVENT_NAME = {
  NAVIGATED: "MY_STABLE_NAVIGATED",
  ENTITY_REMOVED: "My Stable Favorite Removed",
  ENTITY_SELECTED: "My Stable Favorite Selected",
  ALERTS_MODAL_OPENED: "My Stable Alerts Modal Opened",
  ALERTS_APPLIED: "My Stable Alerts Applied",
  PP_MODAL_OPENED: "My Stable PP Modal Opened"
};
